import { dueTone, formatDueLabel, todayInTz, type DueTone, type Task } from '@karya/core';
import { cn } from '@/lib/cn';

export const TONE_CLASS: Record<DueTone, string> = {
  none: 'text-ink-3',
  overdue: 'text-overdue',
  today: 'text-today',
  future: 'text-ink-3',
  done: 'text-ink-3',
};

export function DueLabel({
  task,
  now,
  tz,
  complete,
  pastStyle = 'short',
  className,
}: {
  task: Pick<Task, 'due_date' | 'due_time' | 'due_at'>;
  now: Date;
  tz: string;
  complete?: boolean;
  pastStyle?: 'short' | 'relative';
  className?: string;
}) {
  if (!task.due_date) return null;
  const tone = dueTone(task, now, tz, complete);
  const label = formatDueLabel(
    task.due_date,
    task.due_time?.slice(0, 5) ?? null,
    todayInTz(tz, now),
    { pastStyle },
  );
  return (
    <span className={cn('tabular text-sm whitespace-nowrap', TONE_CLASS[tone], className)}>
      {label}
    </span>
  );
}
